import styled from "styled-components"
import InputEditFlagReventa from "./inputEditFlagReventa.jsx"



let Container=styled.div`
	display:flex;
	flex-direction:column;
	justify-content:space-between;
	width:80%
`;

let ContainerPrecios=styled.div`
	display:flex;
	justify-content:space-around
`;

export default function ModifyPricesReventa(props){
	let {reventa,setNuevosPrecios,nuevosPrecios}=props;


	return(
		<Container>
 			<ContainerPrecios> 							
 				<InputEditFlagReventa codflag="pe" label="Peru" precio={reventa.precio_peru} setNuevosPrecios={setNuevosPrecios} nuevosPrecios={nuevosPrecios}/>
 				<InputEditFlagReventa codflag="us" label="Dolar" precio={reventa.precio_resto} setNuevosPrecios={setNuevosPrecios}   nuevosPrecios={nuevosPrecios}/>
 				<InputEditFlagReventa codflag="ar" label="Argentina" precio={reventa.precio_argentina} setNuevosPrecios={setNuevosPrecios}  nuevosPrecios={nuevosPrecios} />
 				<InputEditFlagReventa codflag="bo" label="Bolivia" precio={reventa.precio_bolivia} setNuevosPrecios={setNuevosPrecios}   nuevosPrecios={nuevosPrecios}/> 							
 			</ContainerPrecios>
 			<ContainerPrecios>
 				<InputEditFlagReventa codflag="cl" label="Chile" precio={reventa.precio_chile} setNuevosPrecios={setNuevosPrecios}  nuevosPrecios={nuevosPrecios} />
 				<InputEditFlagReventa codflag="co" label="Colombia" precio={reventa.precio_colombia} setNuevosPrecios={setNuevosPrecios}  nuevosPrecios={nuevosPrecios} />
 				<InputEditFlagReventa codflag="mx" label="Mexico" precio={reventa.precio_mexico} setNuevosPrecios={setNuevosPrecios}  nuevosPrecios={nuevosPrecios} />
 				<InputEditFlagReventa codflag="uy" label="Uruguay" precio={reventa.precio_uruguay} setNuevosPrecios={setNuevosPrecios}  nuevosPrecios={nuevosPrecios} /> 
 			</ContainerPrecios>		
		</Container>
		)
}